<p-toast position="top-right"></p-toast>

<div class="flex flex-col">
    <!-- HEADER sticky -->
    <div class="card mb-3 l94-sticky-header">
        <div class="flex flex-wrap items-center justify-between gap-3">
            <div>
                <div class="font-semibold text-xl leading-tight">
                    {{ title }}<span *ngIf="sigla" class="text-gray-500"> · {{ sigla }}</span>
                </div>
                <div class="flex items-center gap-2 mt-1">
                    <span class="text-sm text-gray-500">Tolleranze L94</span>
                    <span class="l94-type-badge" *ngIf="selectedTipologiaId">{{ tipologiaLabel }}</span>
                </div>
            </div>
            <div class="flex items-center gap-2">
                <button
                    *ngIf="selectedTipologiaId && !isReadonly"
                    pButton
                    type="button"
                    [label]="identOpen ? 'Chiudi dati' : 'Modifica dati'"
                    [icon]="identOpen ? 'pi pi-times' : 'pi pi-pencil'"
                    severity="warn"
                    (click)="identOpen = !identOpen"
                ></button>
                <button pButton type="button" label="Annulla" severity="secondary" [outlined]="true" (click)="annulla()"></button>
                <button *ngIf="!isReadonly" pButton type="button" icon="pi pi-save" label="Salva" class="p-button-success" [disabled]="saving || !formsValid" (click)="salva()"></button>
            </div>
        </div>
    </div>

    <!-- CONTENUTO -->
    <div class="card">
        <!-- DATI BASE: visibili finché non si sceglie la tipologia, poi spariscono
             (le info restano nell'header). Riapribili con "Modifica dati". -->
        <div class="l94-section" *ngIf="identOpen" [formGroup]="headerForm">
            <div class="l94-section-title">Identificazione</div>
            <div class="l94-grid">
                <div class="l94-field">
                    <label for="sigla">Sigla <span class="req">*</span></label>
                    <input type="text" pInputText id="sigla" formControlName="sigla" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="l94-field">
                    <label for="dettaglio">Dettaglio</label>
                    <input type="text" pInputText id="dettaglio" formControlName="dettaglio" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="l94-field">
                    <label for="tipologia">Tipologia intersezione <span class="req">*</span></label>
                    <p-select
                        id="tipologia"
                        [options]="tipologiaOptions"
                        formControlName="tipologia"
                        optionLabel="labelFe"
                        optionValue="id"
                        [filter]="true"
                        [showClear]="true"
                        [disabled]="isReadonly"
                        appendTo="body"
                        styleClass="w-full"
                        (onChange)="onTipologiaChange($event.value)"
                    ></p-select>
                </div>
            </div>
        </div>

        <!-- MISURAZIONI (tab) -->
        <div class="l94-section" *ngIf="canMisure">
            <div class="l94-section-title">Misurazioni</div>

            <p-tabs [(value)]="activeTab">
                <p-tablist *ngIf="selectedTipologiaId === TipologiaId.Tipo1">
                    <p-tab value="a"><span>Misure</span></p-tab>
                </p-tablist>
                <p-tablist *ngIf="selectedTipologiaId === TipologiaId.Tipo2">
                    <p-tab value="a"><span>1° ramo deviatoio</span></p-tab>
                    <p-tab value="b"><span>2° ramo deviatoio</span></p-tab>
                    <p-tab value="c"><span>Cuore interno</span></p-tab>
                </p-tablist>
                <p-tablist *ngIf="selectedTipologiaId === TipologiaId.Tipo3">
                    <p-tab value="a"><span>Telaio 1</span></p-tab>
                    <p-tab value="b"><span>Telaio 2</span></p-tab>
                    <p-tab value="c"><span>Telaio 3</span></p-tab>
                    <p-tab value="d"><span>Telaio 4</span></p-tab>
                </p-tablist>

                <p-tabpanels style="min-height: 18rem">
                    <p-tabpanel value="a"><ng-container *ngTemplateOutlet="tabContent; context: { config: getTabConfig('a') }"></ng-container></p-tabpanel>
                    <p-tabpanel value="b"><ng-container *ngTemplateOutlet="tabContent; context: { config: getTabConfig('b') }"></ng-container></p-tabpanel>
                    <p-tabpanel value="c"><ng-container *ngTemplateOutlet="tabContent; context: { config: getTabConfig('c') }"></ng-container></p-tabpanel>
                    <p-tabpanel value="d"><ng-container *ngTemplateOutlet="tabContent; context: { config: getTabConfig('d') }"></ng-container></p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        </div>
    </div>
</div>

<!-- ==================== TAB CONTENT ==================== -->
<ng-template #tabContent let-config="config">
    <div [formGroup]="currentForm" class="pt-3">
      <div class="l94-meas">
        <!-- Valori S -->
        <section class="l94-card l94-card-wide" *ngIf="config.sRows.length > 0">
        <div class="l94-card-title">Valori S</div>
        <div class="l94-stables">
            <table class="l94-stable">
                <thead>
                    <tr>
                        <th class="col-s">S</th>
                        <th>Valore</th>
                        <th>Min −</th>
                        <th>Plus +</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let i of config.sRows | slice: 0 : 6">
                        <th class="col-s">S{{ i }}</th>
                        <td><input type="number" pInputText [formControlName]="'s' + i" [readonly]="isReadonly" /></td>
                        <td><input type="number" pInputText [formControlName]="'minS' + i" [readonly]="isReadonly" /></td>
                        <td><input type="number" pInputText [formControlName]="'plusS' + i" [readonly]="isReadonly" /></td>
                    </tr>
                </tbody>
            </table>

            <table class="l94-stable" *ngIf="config.sRows.length > 6">
                <thead>
                    <tr>
                        <th class="col-s">S</th>
                        <th>Valore</th>
                        <th>Min −</th>
                        <th>Plus +</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let i of config.sRows | slice: 6 : 12">
                        <th class="col-s">S{{ i }}</th>
                        <td><input type="number" pInputText [formControlName]="'s' + i" [readonly]="isReadonly" /></td>
                        <td><input type="number" pInputText [formControlName]="'minS' + i" [readonly]="isReadonly" /></td>
                        <td><input type="number" pInputText [formControlName]="'plusS' + i" [readonly]="isReadonly" /></td>
                    </tr>
                </tbody>
            </table>
        </div>
        </section>

        <!-- Condizioni -->
        <section class="l94-card" *ngIf="config.conditions.length > 0">
            <div class="l94-card-title">Condizioni</div>
            <table class="l94-ctable">
                <thead>
                    <tr>
                        <th class="col-c">Condizione</th>
                        <th class="col-op">Operatore</th>
                        <th>Valore</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let cond of config.conditions">
                        <th class="col-c">{{ cond }}</th>
                        <td><p-select [options]="operators" [formControlName]="'op' + cond" [disabled]="isReadonly" styleClass="w-full"></p-select></td>
                        <td><input type="number" pInputText [formControlName]="cond.toLowerCase()" [readonly]="isReadonly" /></td>
                    </tr>
                </tbody>
            </table>
        </section>

        <!-- Quote -->
        <section class="l94-card" *ngIf="config.includePQ || config.includeRTVZ">
            <div class="l94-card-title">Quote</div>
            <div class="l94-quote-grid">
                <div class="l94-field" *ngIf="config.includePQ">
                    <label for="p">P</label>
                    <input type="number" pInputText id="p" formControlName="p" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="l94-field" *ngIf="config.includePQ">
                    <label for="q">Q</label>
                    <input type="number" pInputText id="q" formControlName="q" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="l94-field" *ngIf="config.includeRTVZ">
                    <label for="r">R</label>
                    <input type="number" pInputText id="r" formControlName="r" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="l94-field" *ngIf="config.includeRTVZ">
                    <label for="t">T</label>
                    <input type="number" pInputText id="t" formControlName="t" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="l94-field" *ngIf="config.includeRTVZ">
                    <label for="v">V</label>
                    <input type="number" pInputText id="v" formControlName="v" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="l94-field" *ngIf="config.includeRTVZ">
                    <label for="z">Z</label>
                    <input type="number" pInputText id="z" formControlName="z" [readonly]="isReadonly" class="w-full" />
                </div>
            </div>
        </section>
      </div>
    </div>
</ng-template>
